<template>
    <template v-if="computedUserId">
        <router-link
            v-if="navigateOnClick"
            :to="{ name: 'Profile', params: { id: computedUserId }}"
        >
            <div class="user-avatar-wrap">
                <img
                    :style="avatarStyle"
                    :src="`${$imageURL}Avatar/getUserAvatar?id=${computedUserId}`"
                    alt="Avatar" @error="onErrorImg">
                <div v-if="showBulb && isOnline" :style="bulbStyle" class="online-bulb"></div>
            </div>
        </router-link>
        <div v-else class="user-avatar-wrap">
            <img
                :style="avatarStyle"
                :src="`${$imageURL}Avatar/getUserAvatar?id=${computedUserId}&m=${avatarLastModified}`"
                alt="Avatar" @error="onErrorImg">
            <div v-if="showBulb && isOnline" :style="bulbStyle" class="online-bulb"></div>
        </div>
    </template>
</template>

<script>
export default {
  emits:["no-content"],
  props: {
        user: Object,
        userId: String,
        factor: { type: Number, default: 1 },
        navigateOnClick: { type: Boolean, default: true },
        showBulb: { type: Boolean, default: true }
    },
  computed: {
        computedUserId() {
          return this.user ? this.user.id : this.userId;
        },
        avatarLastModified() {
          return this.user && this.user.avatarLastModified? this.user.avatarLastModified : Date.now();
        },
        isOnline() {
            return this.user ? this.user.isOnline : false;
        },
        avatarStyle() {
            return {
                width: (32 * this.factor).toString() + "px",
                height: (32 * this.factor).toString() + "px",
                borderRadius: (16 * this.factor).toString() + "px",
            }
        },
        bulbStyle() {
            return {
                width: this.factor === 1 ? "8px" : "12px",
                height: this.factor === 1 ? "8px" : "12px",
                borderRadius: this.factor === 1 ? "4px" : "6px",
                right: (3 * this.factor).toString() + "px",
                bottom: (3 * this.factor).toString() + "px"
            }
        }
    },
  methods:{
        onErrorImg(){
            this.$emit("no-content");
        }
    }
}
</script>

<style scoped>
    .user-avatar-wrap {
        display: inline-block;
        position: relative;
    }
    .user-avatar-wrap img {
        object-fit: cover;
        object-position: 50% 50%;
    }
    .user-avatar-wrap .online-bulb {
        background-color: #24D456;
        display: inline-block;
        position: absolute;
        border: 1px solid white;
        box-sizing: border-box;
    }
</style>
